import React, { useEffect, useState } from "react";
import { infoServicio } from "modAws/CatalogoAws";
import CuadroDiagrama from "./CuadroDiagrama";
import { BotonVoz } from "../voz";
import { Glosa } from "../piezas";

// Una leccion: escenas animadas con su texto, una frase para recordar y los servicios que aparecen. Se avanza con «Siguiente».
const Leccion = ({ leccion, escenaInicial = 0, onEscena, onServicio, onTerminar }) => {
    const [i, setI] = useState(Math.min(escenaInicial, leccion.escenas.length - 1));
    useEffect(() => { setI(Math.min(escenaInicial, leccion.escenas.length - 1)); }, [leccion.id]);
    const e = leccion.escenas[i];
    const ir = (k) => { setI(k); if (onEscena) onEscena(k); };
    const ultima = i === leccion.escenas.length - 1;
    return (
        <div className="card mb-3" style={{ borderTop: `4px solid ${leccion.color}` }} data-guia="leccion">
            <div className="card-body">
                <div className="text-muted small mb-1"><i className={`${leccion.icono} me-1`} />Lección: {leccion.titulo} · escena {i + 1} de {leccion.escenas.length}</div>
                <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
                    <h4 className="mb-0 me-auto">{e.titulo}</h4>
                    <BotonVoz texto={`${e.titulo}. ${e.texto} ${e.idea}`} />
                </div>
                <p style={{ fontSize: 17 }}><Glosa texto={e.texto} /></p>
                <CuadroDiagrama key={`${leccion.id}-${i}`} patron="libre" nodos={e.nodos} flujos={e.flujos} grupos={e.grupos} color={leccion.color} falla={e.falla} permitirFalla={!!e.falla} />
                <div className="alert alert-info py-2 mt-3 mb-2"><i className="fa fa-lightbulb me-2" /><b>Para recordar:</b> {e.idea}</div>
                {e.servicios && (
                    <div className="mb-2 small">
                        <span className="text-muted me-2">Servicios que aparecen:</span>
                        {e.servicios.filter(id => infoServicio(id)).map(id => (
                            <button key={id} className="btn btn-sm btn-outline-secondary py-0 me-1" onClick={() => onServicio && onServicio(id)}>
                                <i className={`${infoServicio(id).servicio.icon} me-1`} style={{ color: infoServicio(id).color }} />{infoServicio(id).servicio.title}
                            </button>
                        ))}
                    </div>
                )}
                <div className="d-flex align-items-center gap-2 mt-3">
                    <button className="btn btn-outline-secondary" disabled={i === 0} onClick={() => ir(i - 1)}><i className="fa fa-chevron-left me-1" />Anterior</button>
                    <div className="flex-grow-1 text-center">
                        {leccion.escenas.map((_, k) => (
                            <button key={k} className="btn p-0 mx-1 border-0" style={{ width: 12, height: 12, borderRadius: 6, background: k === i ? leccion.color : "#c9ced3" }} onClick={() => ir(k)} aria-label={`Ir a la escena ${k + 1}`} aria-current={k === i} />
                        ))}
                    </div>
                    {!ultima
                        ? <button className="btn btn-primary" onClick={() => ir(i + 1)}>Siguiente<i className="fa fa-chevron-right ms-1" /></button>
                        : <button className="btn btn-success" onClick={() => onTerminar && onTerminar()}><i className="fa fa-check me-1" />Terminé la lección</button>}
                </div>
            </div>
        </div>
    );
};

export default Leccion;
